export default __webpack_public_path__ + "static/media/pdfBackPage.6e2d9f9d.svg";